module.exports = __webpack_public_path__ + "img/newpc.d1153ae0.png";